import types from 'constants/actionTypes';

const initialState = {
  showCartUpdateMessage: false,
};

const base = (state, { type }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (type) {
    case types.WEBSOCKET_OPEN:
      return state;
    case types.SHOW_CART_UPDATE_MESSAGE:
      return { ...state, showCartUpdateMessage: true };
    case types.HIDE_CART_UPDATE_MESSAGE:
      return { ...state, showCartUpdateMessage: false };
    default:
      return state;
  }
};

export default base;
